const Spinner = ({size = "medium", color = "grey", centered = true}) => {
    return (
        <div className={`ui active ${color} ${size} ${centered && "centered"} inline loader`}></div>
    );
}

export default Spinner;